import theme from '@/constants/theme';
import React from 'react';

interface Props {
  label: string;
  helperText?: string;
  htmlFor?: string;
}

const FormLabel: React.FC<Props> = ({ label, helperText, htmlFor }) => {
  return (
    <label
      htmlFor={htmlFor}
      style={{ display: 'flex', flexDirection: 'column', gap: 4, color: theme.colors.text.body }}
    >
      <span>{label}</span>
      {helperText && <small style={{ color: theme.colors.text.caption }}>{helperText}</small>}
    </label>
  );
};

export default FormLabel;
